// LoadingIndicator.js
import React from "react";
import "./LoadingIndicator.css";

class LoadingIndicator extends React.Component {
  render() {
    if (this.props.loading) {
      return (
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default LoadingIndicator;
